export function cpfResponsavelValido(cpf) {
  if (!cpf) return false;
  return !(cpf.replace(/\D/g, '').length !== 11);
}
